import { enumSocialMediaPostType } from "../../../enums";
import { referenceIsForAFacebookPost } from "../../../utilities/digitalMediaUtilities/externalSourceUtilities/facebookUtilities";
import { referenceIsForAGabPost } from "../../../utilities/digitalMediaUtilities/externalSourceUtilities/gabUtilities";
import { referenceIsForAnInstagramPost } from "../../../utilities/digitalMediaUtilities/externalSourceUtilities/instagramUtilities";
import { referenceIsForALInkedInPost } from "../../../utilities/digitalMediaUtilities/externalSourceUtilities/linkedInUtilities";
import { referenceIsForAPinterestPost } from "../../../utilities/digitalMediaUtilities/externalSourceUtilities/pinterestUtilities";
import { referenceIsForATikTokPost } from "../../../utilities/digitalMediaUtilities/externalSourceUtilities/tiktokUtilities";
import { referenceIsForATruthSocialPost } from "../../../utilities/digitalMediaUtilities/externalSourceUtilities/truthSocialUtilities";
import { referenceIsForATwitterOrXPost } from "../../../utilities/digitalMediaUtilities/externalSourceUtilities/twitterOrXUtilities";
import { referenceIsForAYouTubeAsset } from "../../../utilities/digitalMediaUtilities/externalSourceUtilities/youtubeUtilities";
import { determineSocialMediaPostTypeFromRawReference } from "./determineSocialMediaPostTypeFromRawReference";
import { ISocialMediaPostDisplaySpecs } from "./ISocialMediaPostDisplaySpecs";
import { deriveDisplaySpecsForFacebookPost } from "./socialMediaPostDisplaySpecsUtilities/deriveDisplaySpecsForFacebookPost";
import { deriveDisplaySpecsForInstagram } from "./socialMediaPostDisplaySpecsUtilities/deriveDisplaySpecsForInstagram";
import { deriveDisplaySpecsForLinkedIn } from "./socialMediaPostDisplaySpecsUtilities/deriveDisplaySpecsForLinkedIn";
import { deriveDisplaySpecsForPinterest } from "./socialMediaPostDisplaySpecsUtilities/deriveDisplaySpecsForPinterest";
import { deriveDisplaySpecsForTikTok } from "./socialMediaPostDisplaySpecsUtilities/deriveDisplaySpecsForTikTok";
import { deriveDisplaySpecsForTruthSocial } from "./socialMediaPostDisplaySpecsUtilities/deriveDisplaySpecsForTruthSocial";
import { deriveDisplaySpecsForXOrTwitter } from "./socialMediaPostDisplaySpecsUtilities/deriveDisplaySpecsForXOrTwitter";
import { deriveDisplaySpecsForYouTube } from "./socialMediaPostDisplaySpecsUtilities/deriveDisplaySpecsForYouTube";

/**
 * @function determineSocialMediaPostDisplaySpecsFromRawReference Determines the display specs for a Social Media Post Type from a raw reference
 * @param socialMediaPostRawReference The raw reference associated with the Social Media Post (eg, could be a URL or could be an <iframe>)
 */
export function determineSocialMediaPostDisplaySpecsFromRawReference(socialMediaPostRawReference: string): ISocialMediaPostDisplaySpecs {

  // create a default Display Specs object that will be used as the return value
  let displaySpecs: ISocialMediaPostDisplaySpecs = {
    socialMediaPostType: enumSocialMediaPostType.Undefined,
    url: '',
    width: '100%',
    height: '100%',
  };

  // first, get the Social Media Post Type from the Raw reference
  const socialMediaPostType: enumSocialMediaPostType = determineSocialMediaPostTypeFromRawReference(socialMediaPostRawReference);

  // if the Social Media Post Type is NOT Undefined...
  if (socialMediaPostType !== enumSocialMediaPostType.Undefined) {
    // ...based on the Social Media Post Type, derive the display specs
    switch (socialMediaPostType) {
      case enumSocialMediaPostType.FacebookPost:
        displaySpecs = deriveDisplaySpecsForFacebookPost(socialMediaPostRawReference);
        break;
        
      case enumSocialMediaPostType.Instagram:
        displaySpecs = deriveDisplaySpecsForInstagram(socialMediaPostRawReference);
        break;

      case enumSocialMediaPostType.LinkedIn:
        displaySpecs = deriveDisplaySpecsForLinkedIn(socialMediaPostRawReference);
        break;

      case enumSocialMediaPostType.Pinterest:
        displaySpecs = deriveDisplaySpecsForPinterest(socialMediaPostRawReference);
        break;

      case enumSocialMediaPostType.TikTok:
        displaySpecs = deriveDisplaySpecsForTikTok(socialMediaPostRawReference);
        break;

      case enumSocialMediaPostType.TruthSocial:
        displaySpecs = deriveDisplaySpecsForTruthSocial(socialMediaPostRawReference);
        break;

      case enumSocialMediaPostType.XOrTwitter:
        displaySpecs = deriveDisplaySpecsForXOrTwitter(socialMediaPostRawReference);
        break;

      case enumSocialMediaPostType.YouTube:
        displaySpecs = deriveDisplaySpecsForYouTube(socialMediaPostRawReference);
        break;

      default:
        // do nothing
        break;
    }
  }

  return displaySpecs;
}
